import mark from "@/assets/logo-mark.png";

export function LogoMark({ className = "w-9 h-9" }) {
  return <img src={mark} alt="Arjun Fintech" className={`${className} object-contain`} data-testid="logo-mark" />;
}
